import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { WidgetProgressSpinnerComponent } from './progress-spinner/widget-progress-spinner.component';

@NgModule({
    declarations: [
        WidgetProgressSpinnerComponent
    ],
    imports: [
        CommonModule,
        MatProgressSpinnerModule
    ],
    exports:[
        WidgetProgressSpinnerComponent
    ]
})
export class WidgetModule { }
